import React from 'react'

import { func, string } from 'prop-types'

import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import I18n from 'Pods/Shared/I18n'

import FilterChip from '../../../Shared/FilterChip/FilterChip'

const translate = (key, options) => I18n.t(key, { ns: 'rails', ...options })

// Extracted so each chip subscribes only to the slice it cares about - sibling
// toggles don't trigger this row's re-render.
function PrintAttributesChip({ chipKey, select, onChange }) {
  const isChecked = useSearchPageStore(select)

  return (
    <FilterChip
      id={`print-attr-${chipKey}`}
      label={translate(`search_page.filters.print_attributes.${chipKey}`)}
      isChecked={isChecked}
      onChange={onChange}
    />
  )
}

PrintAttributesChip.propTypes = {
  chipKey: string.isRequired,
  select: func.isRequired,
  onChange: func.isRequired,
}

export default PrintAttributesChip
